import React from 'react';
import { Route } from 'react-router';

const renderMergedProps = (component, ...rest) => {
    const finalProps = Object.assign({}, ...rest);
    return React.createElement(component, finalProps);
};

export const PropsRoute = ({ component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={routeProps => {
                const props = rest.props ? rest.props : {};
                return renderMergedProps(component, routeProps, rest, props);
            }}
        />
    );
};



// WEBPACK FOOTER //
// ./src/components/router/PropsRoute.js